import { render, staticRenderFns } from "./IconSvgEvents.vue?vue&type=template&id=1c167ad1&scoped=true&"
import script from "./IconSvgEvents.vue?vue&type=script&lang=js&"
export * from "./IconSvgEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c167ad1",
  null
  
)

export default component.exports